<template>
  <div class="btn-navigation-back">
    <div class="btn-navigation-back-content" @click="goBack">
      <div class="btn-navigation-back-icon">
        <img src="@/assets/img/ico/lg_left_icon.svg" />
      </div>
      <div class="btn-navigation-back-text">
        {{ $t("action.navigationBack") }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      goBack() {
          this.$router.go(-1)
      },
    },
  };
</script>

<style scoped lang="scss">
  .btn-navigation-back {
    display: flex;
    flex-direction: row;
    padding: 12px 16px;
    align-items: center;

    .btn-navigation-back-content {
      display: flex;
      flex-direction: row;
      gap: 10px;
      cursor: pointer;

      .btn-navigation-back-icon {
        width: 20px;
        height: 20px;
      }

      .btn-navigation-back-text {
        color: var(--CE-Brand-Primaire-Medium, #275CF1);
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
      }
    }
  }
</style>